import Hero from './components/Hero';
import Projects from './components/Projects';
import { personalInfo, projects } from './data/portfolio';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="container">
        <Hero
          name={personalInfo.name}
          title={personalInfo.title}
          bio={personalInfo.bio}
          education={personalInfo.education}
          skills={personalInfo.skills}
          contact={personalInfo.contact}
        />
        <Projects projects={projects} />
      </div>
    </div>
  );
}

export default App;
